import { scrollToBlock } from './goto-top';

if (typeof Livewire != "undefined") {
    console.log("pagination");
    Livewire.on('gotoTop', scrollToBlock)
}
